/**
 * Lager CSV-tekst av overskrifter og rader. Alle celler står i anførselstegn
 * (`"` dobles), skilletegn er `,` og linjeskift er `\n`. Teksten ender med linjeskift.
 */
const celle = (verdi: string | null | undefined): string => `"${(verdi ?? '').replace(/"/g, '""')}"`;

const linje = (celler: (string | null | undefined)[]): string => `${celler.map(celle).join(',')}\n`;

export function lagCsv(overskrifter: string[], rader: (string | null | undefined)[][]): string {
  return linje(overskrifter) + rader.map(linje).join('');
}
